import { render, staticRenderFns } from "./_base-subCard.vue?vue&type=template&id=6374f89e&scoped=true"
import script from "./_base-subCard.vue?vue&type=script&lang=js"
export * from "./_base-subCard.vue?vue&type=script&lang=js"
import style0 from "./_base-subCard.vue?vue&type=style&index=0&id=6374f89e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6374f89e",
  null
  
)

export default component.exports